import { gtmEvent } from '../../utils/gtmEvents';
const gtmInventoryDataLayer = ({ dealerName, model, trim, bodyStyle }) => {
    const gtmPayload = {
        event: 'e_inventoryData',
        dealer_name: dealerName,
        model,
        trim,
        body_style: bodyStyle,
    };
    const filteredPayload = Object.entries(gtmPayload).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});
    gtmEvent(filteredPayload);
};
export default gtmInventoryDataLayer;
